module.exports = [
    {
        "id": 1,
        "name": "Andaman and Nicobar"
    },
    {
        "id": 2,
        "name": "Andhra Pradesh"
    },
    {
        "id": 3,
        "name": "Arunachal Pradesh"
    },
    {
        "id": 4,
        "name": "Assam"
    },
    {
        "id": 5,
        "name": "Bihar"
    },
    {
        "id": 6,
        "name": "Chandigarh"
    },
    {
        "id": 7,
        "name": "Chhattisgarh"
    },
    {
        "id": 8,
        "name": "Dadra and Nagar Haveli"
    },
    {
        "id": 9,
        "name": "Daman and Diu"
    },
    {
        "id": 10,
        "name": "Delhi"
    },
    {
        "id": 11,
        "name": "Goa"
    },
    {
        "id": 12,
        "name": "Gujarat"
    },
    {
        "id": 13,
        "name": "Haryana"
    },
    {
        "id": 14,
        "name": "Himachal Pradesh"
    },
    {
        "id": 15,
        "name": "Jammu and Kashmir"
    },
    {
        "id": 16,
        "name": "Jharkhand"
    },
    {
        "id": 17,
        "name": "Karnataka"
    },
    {
        "id": 18,
        "name": "Kerala"
    },
    {
        "id": 19,
        "name": "Lakshadweep"
    },
    {
        "id": 20,
        "name": "Madhya Pradesh"
    },
    {
        "id": 21,
        "name": "Maharashtra"
    },
    {
        "id": 22,
        "name": "Manipur"
    },
    {
        "id": 23,
        "name": "Meghalaya"
    },
    {
        "id": 24,
        "name": "Mizoram"
    },
    {
        "id": 25,
        "name": "Nagaland"
    },
    {
        "id": 26,
        "name": "Orissa"
    },
    {
        "id": 27,
        "name": "Pondicherry"
    },
    {
        "id": 28,
        "name": "Punjab"
    },
    {
        "id": 29,
        "name": "Rajasthan"
    },
    {
        "id": 30,
        "name": "Sikkim"
    },
    {
        "id": 31,
        "name": "Tamil Nadu"
    },
    {
        "id": 32,
        "name": "Tripura"
    },
    {
        "id": 33,
        "name": "Uttar Pradesh"
    },
    {
        "id": 34,
        "name": "Uttarakhand"
    },
    {
        "id": 35,
        "name": "West Bengal"
    },
    {
        "id": 36,
        "name": "Telangana"
    },
    {
        "id": 37,
        "name": "Ladakh"
    },
    {
        "id": 99,
        "name": "Outside India"
    }
]